<h4>{{ labels.header }}</h4>

<div [formGroup]="form">
  <!-- Row 1: First Name, Last Name & Company -->
  <div class="row">
    <div class="col-md-4">
      <div class="form-group mb-3">
        <label for="firstName" class="form-label"
          >{{ labels.firstName }} <span class="ast">*</span></label
        >
        <input
          type="text"
          id="firstName"
          class="form-control"
          formControlName="firstName"
          [class.is-invalid]="isFieldInvalid('firstName')"
          placeholder="{{ placeholders.enterYourFirstName }}"
          maxlength="100"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('firstName')">
          <span *ngIf="form.get('firstName')?.hasError('required')">
            {{ messages.fieldRequired }}
          </span>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group mb-3">
        <label for="lastName" class="form-label"
          >{{ labels.lastName }} <span class="ast">*</span></label
        >
        <input
          type="text"
          id="lastName"
          class="form-control"
          formControlName="lastName"
          [class.is-invalid]="isFieldInvalid('lastName')"
          placeholder="{{ placeholders.enterYourLastName }}"
          maxlength="100"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('lastName')">
          <span *ngIf="form.get('lastName')?.hasError('required')">
            {{ messages.fieldRequired }}
          </span>
        </div>
      </div>
    </div>

    <div class="col-md-4">
      <div class="form-group mb-3">
        <label for="company" class="form-label" m>{{ labels.company }}</label>
        <input
          type="text"
          id="company"
          class="form-control"
          formControlName="company"
          placeholder="{{ placeholders.enterYourCompanyName }}"
          maxlength="100"
        />
      </div>
    </div>
  </div>

  <!-- Row 2: Email Address & Confirm Email -->
  <div class="row">
    <div class="col-md-6">
      <div class="form-group mb-3">
        <label for="email" class="form-label"
          >{{ labels.emailAddress }} <span class="ast">*</span></label
        >
        <input
          type="email"
          id="email"
          class="form-control"
          formControlName="email"
          [class.is-invalid]="isFieldInvalid('email')"
          placeholder="your.email@example.com"
          maxlength="100"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('email')">
          <span *ngIf="form.get('email')?.hasError('required')">
            {{ messages.fieldRequired }}
          </span>
          <span *ngIf="form.get('email')?.hasError('email')">
            {{ messages.validEmail }}
          </span>
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group mb-3">
        <label for="confirmEmail" class="form-label"
          >{{ labels.confirmEmail }} <span class="ast">*</span></label
        >
        <input
          type="email"
          id="confirmEmail"
          class="form-control"
          formControlName="confirmEmail"
          (paste)="$event.preventDefault()"
          [class.is-invalid]="
            isFieldInvalid('confirmEmail') || hasEmailMismatch()
          "
          placeholder="{{ placeholders.confirmEmailAddress }}"
          maxlength="100"
        />
        <div class="invalid-feedback" *ngIf="isFieldInvalid('confirmEmail')">
          <span *ngIf="form.get('confirmEmail')?.hasError('required')">
            {{ messages.confirmEmail }}
          </span>
          <span *ngIf="form.get('confirmEmail')?.hasError('email')">
            {{ messages.validEmail }}
          </span>
        </div>
        <div class="invalid-feedback" *ngIf="hasEmailMismatch()">
          {{ messages.emailNotMatch }}
        </div>
      </div>
    </div>
  </div>

  <!-- Row 3: Country & Preferred Language -->
  <div class="row">
    <div class="col-md-6">
      <div class="form-group mb-4">
        <label for="country" class="form-label"
          >{{ labels.country }} <span class="ast">*</span></label
        >
        <select
          id="country"
          class="form-control"
          formControlName="country"
          [class.is-invalid]="isFieldInvalid('country')"
        >
          <option value="" disabled selected>
            {{ placeholders.selectYourCountry }}
          </option>
          <option *ngFor="let country of topCountries" [value]="country.name">
            {{ country.name }}
          </option>
          <option disabled>──────────────────</option>
          <option *ngFor="let country of countries" [value]="country.name">
            {{ country.name }}
          </option>
        </select>
        <div class="invalid-feedback" *ngIf="isFieldInvalid('country')">
          {{ messages.fieldRequired }}
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group mb-4">
        <label for="preferredLanguage" class="form-label"
          >{{ labels.preferredLanguage }} <span class="ast">*</span></label
        >
        <select
          id="preferredLanguage"
          class="form-control"
          formControlName="preferredLanguage"
          [class.is-invalid]="isFieldInvalid('preferredLanguage')"
        >
          <option value="" disabled selected>
            {{ placeholders.selectPreferredLang }}
          </option>
          <option
            *ngFor="let language of filteredLanguages"
            [value]="language.code"
          >
            {{ language.name }}
          </option>
        </select>
        <div
          class="invalid-feedback"
          *ngIf="isFieldInvalid('preferredLanguage')"
        >
          {{ messages.fieldRequired }}
        </div>
      </div>
    </div>
  </div>

  <!-- Row 4: Terms Agreement -->
  <div class="row">
    <div class="col-md-12">
      <div class="form-group mb-3">
        <div class="form-check">
          <input
            type="checkbox"
            id="agreeTerms"
            class="form-check-input"
            formControlName="agreeTerms"
            [class.is-invalid]="isFieldInvalid('agreeTerms')"
          />
          <label
            for="agreeTerms"
            class="form-check-label"
            [innerHTML]="'&nbsp; ' + labels.terms"
          >
          </label>
          <span class="ast">*</span>
          <div class="invalid-feedback" *ngIf="isFieldInvalid('agreeTerms')">
            {{ messages.fieldRequired }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Row 5: Cloudflare Turnstile -->
  <div class="row">
    <div class="col-md-12">
      <div class="form-group mb-3">
        <ngx-turnstile
          [siteKey]="siteKey"
          (resolved)="onCaptchaResolved($event)"
        >
        </ngx-turnstile>
        <div class="invalid-feedback d-block" *ngIf="isFieldInvalid('turnstile')">
               {{ messages.fieldRequired }}
        </div>
      </div>
    </div>
  </div>

  <div class="alert alert-danger mt-3" *ngIf="showValidationError">
    {{ messages.validation }}
  </div>

  <div class="alert alert-danger mt-3" *ngIf="showSubmissionError">
    {{ messages.error }}
  </div>

  <div class="d-flex justify-content-between">
    <button type="submit" class="btn btn-primary" [disabled]="loaderIcon">
      {{ labels.submit }}
      <span *ngIf="loaderIcon" class="fa fa-spinner fa-spin fa-1x"></span>
    </button>
  </div>
</div>
